import { gql } from "graphql-request";

export const ADMIN_REFUND_SUBSCRIPTION = gql`
  mutation AdminRefundSubscription($input: AdminRefundInputDto!) {
    adminRefundSubscription(input: $input) {
      success
      message
    }
  }
`;


export const ADMIN_UPGRADE_SUBSCRIPTION = gql`
  mutation AdminUpgradeSubscription($input: AdminUpgradeInputDto!) {
    adminUpgradeSubscription(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_GRANT_CREDITS = gql`
  mutation AdminGrantCredits($input: AdminGrantCreditsInputDto!) {
    adminGrantCredits(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_EXTEND_BILLED_SUBSCRIPTION = gql`
  mutation AdminExtendBilledSubscription(
    $input: AdminExtendBilledSubscriptionInputDto!
  ) {
    adminExtendBilledSubscription(input: $input) {
      success
      message
    }
  }
`;
